const convertCentsToDecimalString = (cents) => `${(cents / 100).toFixed(2)}`;
export {
  convertCentsToDecimalString
};
//# sourceMappingURL=convert-cents-to-decimal-string.js.map
